/**
 * Shared project root resolution for MCP tools.
 *
 * Checks WORKSPACE_PATH, cwd, and parent of cwd for a Convex project
 * (convex/schema.ts marker). Returns null if no valid root is found.
 */

import { existsSync } from "node:fs";
import { resolve } from "node:path";

export function resolveProjectRoot(): string | null {
  const candidates = [
    process.env.WORKSPACE_PATH,
    process.cwd(),
    // Parent of cwd: handles monorepo subpackages (e.g. packages/mcp-server)
    // where the Convex schema lives one level up.
    resolve(process.cwd(), ".."),
  ].filter(Boolean) as string[];

  for (const dir of candidates) {
    const resolved = resolve(dir);
    if (existsSync(resolve(resolved, "convex/schema.ts"))) return resolved;
  }
  return null;
}
